/** @file Module-level Float32Array scratch for world positions; grows by doubling, never shrinks. */

let scratch = new Float32Array(1024);

/** A scratch Float32Array with at least `floats` entries; reallocates only when it must grow (never per frame). */
export function positionScratch(floats: number): Float32Array {
  if (scratch.length < floats) {
    let size = scratch.length;
    while (size < floats) size *= 2;
    scratch = new Float32Array(size);
  }
  return scratch;
}
